import { constants as orderConstants } from 'utils/order';

const initialState = {
  type: 'directOrder',
  isRecurring: false,
  isEditing: false,
  originalPrice: {},
  maxNumberOfItems: undefined,
  maximumOfItemsInLoads: undefined,
  maxReached: false,
  paymentIntentSecret: '',
  lastId: '',
  holidays: {},
  validations: orderConstants.DEFAULT_VALIDATIONS,
  quoteSuggestions: [],
  shipperQuoteId: null,
  timeWindows: [],
  timeWindowsRequestPayload: {},
  isEconomyModeEnabled: false,
};

const initialStateForTest = {
  type: 'directOrder',
  isRecurring: false,
  isEditing: false,
  originalPrice: {},
  maxNumberOfItems: undefined,
  maximumOfItemsInLoads: undefined,
  maxReached: false,
  paymentIntentSecret: '',
  lastId: '',
  holidays: {},
  validations: orderConstants.DEFAULT_VALIDATIONS,
  quoteSuggestions: [],
  shipperQuoteId: null,
  timeWindows: [],
  timeWindowsRequestPayload: {},
};

export default initialState;
export { initialStateForTest };
